<template>
  <div class="single-blog-menu d-flex-column order-game-selector md-col-to-row">
    <p class="title">Table of Contents</p>
    <div
      class="d-flex-column gap-3 md-col-to-row games_list align-start justify-start"
      style="padding: 6px"
    >
      <button
        exact-active-class="active"
        class="pack_selector link"
        v-for="content in tableOfContent"
        :key="content"
        @click="customScroll(content.id)"
      >
        <p class="white-space-no medium-l font-family-2 t-white f-w-500">
          {{ content.text }}
        </p>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    tableOfContent: {
      default: [],
    },
  },
  methods: {
    customScroll(id) {
      let element = document.getElementById(id);
      element.scrollIntoView({ behavior: "smooth" });
    },
  },
  beforeMount() {},
};
</script>
